/* Next10 — troca de variante nos cards da vitrine.
   Atualiza imagem, preco, preco comparado, selo de desconto e link do produto
   quando o cliente escolhe outro sabor na pilula do card.
   Tambem calcula o tamanho da foto no hover do desktop (ver medirHover). */
(function () {
  if (window.__n10CardVariantes) return;
  window.__n10CardVariantes = true;

  function dados(card) {
    var el = card.querySelector('.n10-card__dados');
    if (!el) return null;
    if (el.__n10cache !== undefined) return el.__n10cache;
    try { el.__n10cache = JSON.parse(el.textContent); }
    catch (e) { el.__n10cache = null; }
    return el.__n10cache;
  }

  function aplicar(card, v, esconderAlt) {
    var img = card.querySelector('.n10-card__img:not(.n10-card__img--alt)');
    if (img && v.img600) {
      img.setAttribute('src', v.img600);
      img.setAttribute('srcset', v.img300 + ' 300w, ' + v.img600 + ' 600w, ' + v.img900 + ' 900w');
      if (v.alt) img.setAttribute('alt', v.alt);
      if (esconderAlt) {
        var alt = card.querySelector('.n10-card__img--alt');
        if (alt) alt.style.display = 'none';
      }
    }

    var preco = card.querySelector('.n10-card__price');
    if (preco && v.preco) preco.textContent = v.preco;

    var comparar = card.querySelector('.n10-card__compare');
    if (comparar) {
      if (v.comparar) {
        comparar.textContent = v.comparar;
        comparar.style.display = '';
      } else {
        comparar.style.display = 'none';
      }
    }

    var selo = card.querySelector('.n10-card__badge:not(.n10-card__badge--esgotado)');
    if (selo) {
      if (v.desconto > 0) {
        selo.textContent = '-' + v.desconto + '%';
        selo.style.display = '';
      } else {
        selo.style.display = 'none';
      }
    }

    var link = card.querySelector('.n10-card__link');
    if (link && v.url) link.setAttribute('href', v.url);
  }

  function trocar(input, esconderAlt) {
    var card = input.closest ? input.closest('.n10-card') : null;
    if (!card) return;
    var lista = dados(card);
    if (!lista) return;
    for (var i = 0; i < lista.length; i++) {
      if (String(lista[i].id) === String(input.value)) {
        aplicar(card, lista[i], esconderAlt);
        return;
      }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('n10-card__opt-input')) {
      trocar(t, true);
    }
  });

  function inicial() {
    var marcados = document.querySelectorAll('.n10-card__opt-input:checked');
    for (var i = 0; i < marcados.length; i++) trocar(marcados[i], false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicial);
  } else {
    inicial();
  }

  /* ------------------------------------------------------------------
     Foto no hover (desktop): mede o painel que sobe (nome + preço +
     sabores + botão) e calcula quanto a foto pode ter para ocupar todo o
     espaço acima dele. Grava --n10-hover-y/--n10-hover-s, lidos pelo
     n10-card.css. Só leitura de offset* (não muda com os transforms),
     uma vez por entrada do mouse no card.
     SOBRA: as fotos são PNG com margem transparente (>= 6% em cima e
     embaixo em todo o catálogo), então a caixa pode passar um pouco das
     bordas sem o produto encostar no nome.
     ------------------------------------------------------------------ */
  var hoverMq = window.matchMedia('(min-width: 750px) and (hover: hover)');
  var TOPO = 8;
  var RESPIRO = 6;
  var SOBRA = 0.06;

  function medirHover(card) {
    if (!hoverMq.matches) return;
    var media = card.querySelector('.n10-card__media');
    var img = card.querySelector('.n10-card__img:not(.n10-card__img--alt)');
    var info = card.querySelector('.n10-card__info');
    if (!media || !img || !info) return;
    /* grade da coleção: painel fixo embaixo, sem efeito de hover */
    if (getComputedStyle(info).position !== 'absolute') return;

    var mh = media.offsetHeight;
    var ih = img.offsetHeight;
    var painel = info.offsetHeight;
    var livre = mh - painel - TOPO - RESPIRO;
    if (!mh || !ih || livre <= 0) return;

    var s = Math.min(livre / (1 - 2 * SOBRA) / ih, 1);
    /* media escala a partir do próprio centro; leva o centro da foto
       para o meio do espaço livre */
    var centroMedia = mh / 2;
    var centroImg = img.offsetTop + ih / 2;
    var y = TOPO + livre / 2 - centroMedia - s * (centroImg - centroMedia);

    card.style.setProperty('--n10-hover-s', s.toFixed(3));
    card.style.setProperty('--n10-hover-y', Math.round(y) + 'px');
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.n10-card') : null;
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) medirHover(card);
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.n10-card') : null;
    if (card) medirHover(card);
  });
})();
